module.exports = __webpack_public_path__ + "img/resized952016062295201157.5aa9c378.jpg";